import NykForm from "./NykForm/NykForm.vue"

export default {
  name: "CustomForm",
  components: {
    NykForm
  }
}
